export default [
    {
        name: 'Stříbrná',
        code: '#C0C0C0',
    },
    {
        name: 'Šedá',
        code: '#808080',
    },
    {
        name: 'Černá',
        code: '#000000',
    },
    {
        name: 'Červená',
        code: '#FF0000',
    },
    {
        name: 'Vínová',
        code: '#B22222',
    },
    {
        name: 'Žlutá',
        code: '#FFFF00',
    },
    {
        name: 'Olivová',
        code: '#808000',
    },
    {
        name: 'Světle zelená',
        code: '#00FF00',
    },
    {
        name: 'Zelená',
        code: '#008000',
    },
    {
        name: 'Světle modrá',
        code: '#00FFFF',
    },
    {
        name: 'Zelenomodrá',
        code: '#008080',
    },
    {
        name: 'Modrá',
        code: '#0000FF',
    },
    {
        name: 'Tmavě modrá',
        code: '#000080',
    },
    {
        name: 'Růžová',
        code: '#FF00FF',
    },
    {
        name: 'Fialová',
        code: '#800080',
    },
]
